{
	"title": "Åpen kildekode programvareattribusjon",
	"backTitle": "Tilbake"
}
